import script from "./CreateLabelCategoryDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateLabelCategoryDialog.vue?vue&type=script&setup=true&lang=js"

import "./CreateLabelCategoryDialog.vue?vue&type=style&index=0&id=198db2a4&lang=css"
import "./CreateLabelCategoryDialog.vue?vue&type=style&index=1&id=198db2a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-198db2a4"]])

export default __exports__